import { Entity } from "app/models/entity";
import { IPagination } from "../_apiResponse";

export interface ClientsPaginated extends IPagination<Client> { }

export const sqlTable = 'clients'

export interface Client extends Entity {
    business_name: string
    displayed_name: string
    vat_number: string
    fiscal_code: string
    address: string
    zip_code: string
    city: string
    province: string
    email: string
    phone: string
    sdi: string
    note: string
}

export const emptyClient = {
    id: 0,
    business_name: '',
    displayed_name: '',
    vat_number: '',
    fiscal_code: '',
    address: '',
    zip_code: '',
    city: '',
    province: '',
    email: '',
    phone: '',
    sdi: '',
    note: '',
}
